<template>
  <div :class="['nav-option', { 'nav-cover': isCover }]">
    <div class="option-contents" ref="rightBox">
      <transition-group
        v-for="(tab, index) of tabs"
        :key="tab.name"
        name="list"
        class="content-menu"
        tag="div"
        v-show="currentTabId == index"
      >
        <div class="logo-wrapper" v-if="tab.name === 'logo'" :key="tab.name">
          <div class="logo-switch">
            <el-switch v-model="isLogo" active-color="#3f69f9"></el-switch>
            <span class="name">{{ isLogo ? "启用" : "禁用" }}角标</span>
          </div>
          <div :class="['logo-modes', { 'logo-disabled': !isLogo }]">
            <span
              v-for="item of logoTypes"
              :key="item.id"
              :class="['item', { on: selectedLogoMode === item.id }]"
              @click="selectLogoMode(item.id)"
              >{{ item.name }}</span
            >
          </div>
          <div :class="['logo-input', { 'logo-disabled': !isLogo }]" v-if="selectedLogoMode === 1">
            <span class="label">输入文案</span>
            <input
              type="text"
              class="logo-name"
              :value="onDrawData.logoContent"
              @input="changeLogoContent"
              :disabled="!isLogo"
              maxlength="11"
              minlength="4"
              placeholder="输入文案4-11个字"
            />
          </div>
          <site-choice
            v-if="selectedLogoMode === 2"
            :class="['logo-choices', { 'logo-disabled': !isLogo }]"
            @pickSite="logoId => isLogo && $emit('pickLogo', logoId)"
            :logoOptions="logoOptions"
            :selectedSiteIds="[onDrawData.logoContent]"
          />
        </div>
        <template v-else>
          <div
            v-for="item of tab.getMenus()"
            :key="item.id"
            @click="selectMaterial(item, tab.name)"
            :class="[tab.name + '-item']"
          >
            <template v-if="tab.name === 'background'">
              <img v-lazy="`//bar.xkw.com${item.src}`" />
              <i v-show="onDrawData.backgroundId === item.id" class="iconfont icon-gouxuan"></i>
            </template>
            <el-popover v-if="tab.name === 'element'" :disabled="!popoverVisible" placement="left" width="214">
              <p>选择元素会覆盖现有照片哦～</p>
              <div class="popover-btn">
                <Button value="取消" size="small" type="borderLight" @click="popoverVisible = false" />
                <Button value="确定" size="small" type="borderLight" @click="popoverConfirm(item)" />
              </div>
              <div slot="reference">
                <img v-lazy="`//bar.xkw.com${item.src}`" :class="isCover || remainPart ? 'img-offset' : ''" />
                <i v-show="onDrawData.elementId === item.id" class="iconfont icon-gouxuan"></i>
              </div>
            </el-popover>
            <template v-if="tab.name === 'content-style'">
              <div class="poster-content">
                <img :src="`//bar.xkw.com${item.filePath}`" class="content-bg" />
                <h5 class="title">内容简介</h5>
              </div>
              <i v-show="item.id === contentLabelStyleId" class="iconfont icon-gouxuan"></i>
            </template>
            <template v-if="tab.name === 'text-style'">
              <div
                class="style"
                v-for="(text, index) of item.styles"
                :key="index"
                :style="{ fontFamily: text.fontFamily }"
              >
                {{ text.fontFamily }}
              </div>
              <i v-show="item.id === onDrawData.textStyleId" class="iconfont icon-gouxuan"></i>
            </template>
          </div>
        </template>
        <img
          v-if="!tab.getMenus() || !tab.getMenus().length"
          class="nothing"
          key="-1"
          src="@/assets/images/index/404.png"
        />
      </transition-group>
    </div>
    <div class="option-tabs">
      <img class="tab-bg" src="@/assets/images/index/option.png" :style="currentTabBgStyle" />
      <div class="tab" v-for="(tab, index) of tabs" :key="index" @click="tabChange(index)">
        <img :src="tab.iconUrl" />
        <span class="text">{{ tab.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { isPortraitMaterialType } from "@/assets/scripts/common";
import Button from "@/components/weButton.vue";
import siteChoice from "@/pages/poster/components/site-choice.vue";
import { mapState } from "vuex";
export default {
  props: {
    contentLabelStyleId: {
      type: Number,
      default: 0,
    },
    isCover: {
      type: Boolean,
      default: false,
    },
    backgrounds: {
      type: Array,
      default: () => [],
    },
    elements: {
      type: Array,
      default: () => [],
    },
    textStyles: {
      type: Array,
      default: () => [],
    },
    contentStyles: {
      type: Array,
      default: () => [],
    },
    // 正在绘制的数据
    onDrawData: {
      type: Object,
      default: () => ({}),
    },
    // 素材保留部分
    remainPart: {
      type: Number,
      default: 0,
    },
    // 是否需要展示内容区样式
    isContentStyle: {
      type: Boolean,
      default: false,
    },
    isShowBgConfig: {
      type: Boolean,
      default: true,
    },
    isShowElementConfig: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tabs: [],
      // 当前展示的tab
      currentTabId: 0,
      // 当前展示的tab背景的样式
      currentTabBgStyle: {
        top: "20px",
      },
      // 角标文案
      logoName: "",
      // 角标模式
      selectedLogoMode: 2,
      // 角标类型
      logoTypes: [
        {
          id: 2,
          name: "logo角标",
        },
        {
          id: 1,
          name: "文字角标",
        },
      ],
    };
  },
  components: {
    Button,
    siteChoice,
  },
  computed: {
    ...mapState("banner", ["logoOptions"]),
    calTextStyles() {
      if (this.isCover) {
        const textStyles = JSON.parse(JSON.stringify(this.textStyles));
        for (let item of textStyles) {
          item.id = item.materialTextStyleId;
          item.styles = item.styles.filter(style => /Heavy|Black/.test(style.fontFamily));
        }
        return textStyles;
      } else {
        return this.textStyles;
      }
    },
    // 是否选中教师头像
    popoverVisible: {
      get() {
        return isPortraitMaterialType(this.onDrawData.elementTypeId);
      },
      set(val) {
        console.log(val);
      },
    },
    // 选中的站点
    selectedLogos() {
      return [];
    },
    // 是否启用角标
    isLogo: {
      get() {
        return this.onDrawData?.logoConfig?.isLogo ? true : false;
      },
      set(val) {
        this.$emit("updateIsLogo", {
          ...this.onDrawData.logoConfig,
          isLogo: val ? 1 : 0,
        });
      },
    },
    // newTabs() {
    //   let styles = [];
    //   debugger;
    //   if (this.isShowBgConfig) {
    //     styles.push({
    //       name: "background",
    //       iconUrl: require("@/assets/images/index/bg-icon.png"),
    //       text: "背景",
    //       getMenus: () => this.backgrounds,
    //     });
    //   }
    //   styles = [
    //     ...styles,
    //     {
    //       name: "element",
    //       iconUrl: require("@/assets/images/index/el-icon.png"),
    //       text: "元素",
    //       getMenus: () => this.elements,
    //     },
    //     {
    //       name: "text-style",
    //       iconUrl: require("@/assets/images/index/ft-icon.png"),
    //       text: "文字",
    //       getMenus: () => this.calTextStyles,
    //     },
    //   ];
    //   if (this.isContentStyle) {
    //     styles.splice(2, 0, {
    //       name: "content-style",
    //       iconUrl: require("@/assets/images/index/content-icon.png"),
    //       text: "内容",
    //       getMenus: () => this.contentStyles,
    //     });
    //   }
    //   if (this.onDrawData.logoConfig) {
    //     styles.push({
    //       name: "logo",
    //       iconUrl: require("@/assets/images/index/ft-icon.png"),
    //       text: "logo",
    //       getMenus: () => this.logoOptions,
    //     });
    //   }
    //   return styles;
    // },
  },
  mounted() {
    this.tabs = this.genTabs();
  },
  methods: {
    // 生成背景、元素、内容样式、文字样式的数据
    genTabs() {
      let styles = [];
      if (this.isShowBgConfig) {
        styles.push({
          name: "background",
          iconUrl: require("@/assets/images/index/bg-icon.png"),
          text: "背景",
          getMenus: () => this.backgrounds,
        });
      }
      styles = [...styles];
      if (this.isShowElementConfig) {
        styles.push({
          name: "element",
          iconUrl: require("@/assets/images/index/el-icon.png"),
          text: "元素",
          getMenus: () => this.elements,
        });
      }
      if (this.isContentStyle) {
        styles.push({
          name: "content-style",
          iconUrl: require("@/assets/images/index/content-icon.png"),
          text: "内容",
          getMenus: () => this.contentStyles,
        });
      }
      styles.push({
        name: "text-style",
        iconUrl: require("@/assets/images/index/ft-icon.png"),
        text: "文字",
        getMenus: () => this.calTextStyles,
      });
      if (this.onDrawData.logoConfig) {
        styles.push({
          name: "logo",
          iconUrl: require("@/assets/images/index/ft-icon.png"),
          text: "logo",
          getMenus: () => this.logoOptions,
        });
      }
      return styles;
    },
    // 切换素材/背景/文字
    tabChange(index) {
      this.currentTabId = index;
      this.currentTabBgStyle = {
        top: `${20 + 90 * index}px`,
      };
    },
    // 选择素材
    selectMaterial(material, tabName) {
      if (tabName === "background") {
        // 更新背景属性
        this.$emit("updateBackground", material);
        return;
      }
      if (tabName === "element" && !this.popoverVisible) {
        // 更新元素属性
        this.$emit("updateElement", material);
        return;
      }
      if (tabName === "text-style") {
        this.$emit("updateTextStyle", material);
        return;
      }
      if (tabName === "content-style") {
        this.$emit("updateContentStyle", material.id);
      }
    },
    // 确认覆盖元素
    popoverConfirm(material) {
      this.$emit("switchElement", material);
      this.popoverVisible = false;
    },
    // 选择角标模式
    selectLogoMode(id) {
      if (!this.isLogo) return;
      this.selectedLogoMode = id;
    },
    changeLogoContent(e) {
      this.$emit("changeLogoContent", e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

.nav-option {
  position: fixed;
  top: 60px;
  bottom: 60px;
  right: 0;
  display: flex;
  justify-content: space-between;
  width: 400px;
  background: #eceef5;
  z-index: 999;

  .option-contents {
    width: calc(100% - 80px);
    box-sizing: border-box;
    overflow: auto;
    padding: 30px 20px;
    text-align: center;
    background: #fff;
    @include scroller;

    .element-item,
    .background-item,
    .text-style-item {
      position: relative;
      height: 70px;
      margin-bottom: 15px;
      border-radius: 8px;
      font-size: 15px;
      overflow: hidden;
      background: url("../assets/images/index/grid-bg_min.png") 0 0;
      background-size: cover;
      cursor: pointer;

      img {
        display: block;
        height: 70px;
      }
    }

    .text-style-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .icon-gouxuan {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: #fff;
      background: rgba(0, 0, 0, 0.4);
      line-height: 84px;
      z-index: 10;
      border-radius: 8px;
    }

    .content-style-item {
      position: relative;
      margin-bottom: 15px;
      border-radius: 8px;
      background: #f4f5f9;
      cursor: pointer;

      .poster-content {
        transform-origin: left center;
        transform: scale(0.75) translateX(16px);

        img {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 0;
          width: 100%;
          height: 100%;
        }
      }

      .icon-gouxuan {
        line-height: 212px;
      }
    }

    .nothing {
      margin-top: 180%;
      opacity: 0.7;
    }

    .element-item {
      .img-offset {
        margin-left: -105px;
      }
    }

    .logo-wrapper {
      text-align: left;

      .logo-switch {
        display: flex;
        gap: 8px;
        align-items: center;

        .name {
          font-size: 16px;
          color: #666;
          font-weight: 600;
        }
      }

      .logo-modes {
        margin-top: 36px;
        display: flex;
        align-items: center;
        border-radius: 8px;
        overflow: hidden;
        width: 100%;

        .item {
          width: 50%;
          height: 40px;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          text-align: center;
          font-weight: 600;
          background: #f1f2f5;
          box-shadow:
            -1px -1px 1px 0px #eceef5 inset,
            0px 1px 0px 0px #fff inset;
          cursor: pointer;

          &.on {
            background: #3f69f9;
            color: #fff;
          }
        }

        &.logo-disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
      }

      .logo-input {
        margin-top: 24px;

        .label {
          color: #333;
          font-size: 16px;
          font-weight: 500;
          line-height: 16px;

          &:before {
            content: "*";
            color: #ff4d4f;
          }
        }

        .logo-name {
          display: block;
          margin-top: 16px;
          padding: 0 15px;
          width: 252px;
          height: 40px;
          border-radius: 8px;
          border: 1px solid #6d7278;
          background: #fff;
        }

        &.logo-disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }

      .logo-choices {
        margin-top: 24px;

        &.logo-disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }

  .option-tabs {
    position: relative;
    width: 80px;
    height: 300px;
    padding: 25px 0;
    text-align: center;
    cursor: pointer;
    flex: 1;
    z-index: 1;

    .tab-bg {
      position: absolute;
      width: 80px;
      height: 90px;
      top: 10%;
      left: 0;
      z-index: -1;
      transition: all 0.2s ease;
    }

    .tab {
      padding: 14px 0;
      height: 90px;

      img {
        width: 41%;
        display: block;
        margin: 0 auto;
      }

      .text {
        display: block;
        font-size: 14px;
      }
    }
  }

  &.nav-cover {
    width: 300px;

    .option-contents {
      .item {
        height: 84px;

        img {
          width: 336px;
          height: 84px;
          transform: translateX(-157px);
        }
      }
    }
  }
}

.popover-btn {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.list-enter-active {
  transition: all 0.5s;
}

.list-leave-active {
  position: absolute;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}
</style>
